export default __webpack_public_path__ + "static/media/moon-of-appalacia.9413077d.jpg";